import { Clock, MapPin } from "lucide-react";
import React from 'react';
import { useTranslation } from 'react-i18next'; // ADD THIS IMPORT
import { SectionTitle } from "./SectionTitle";

interface LocationSectionProps {
  location: any;
  colors?: any;
}

export const LocationSection: React.FC<LocationSectionProps> = ({
  location,
  colors = {}
}) => {
  const { t } = useTranslation(); // ADD THIS LINE

  const defaultColors = {
    cardBackground: "#000000F2",
    cardBorder: "#DDB88919",
    cardShadow: "rgba(221,184,137,0.07)",
    cardShadowSelected: "rgba(221,184,137,0.1)",
    titleText: "#DDB889",
    subtitleText: "#DDB889CC",
    infoText: "#DDB88999",
    iconColor: "#DDB889"
  };

  // Merge default colors with provided colors
  const mergedColors = { ...defaultColors, ...colors };

  // Create style objects from the colors
  const cardStyle = {
    backgroundColor: mergedColors.cardBackground,
    borderColor: mergedColors.cardBorder,
    boxShadow: `0 0 15px ${mergedColors.cardShadow}`
  };

  const iconStyle = {
    color: mergedColors.iconColor
  };

  const textStyle = {
    color: mergedColors.subtitleText
  };

  const textHoverStyle = {
    color: mergedColors.titleText
  };

  return (
    <div
      className="lp-backdrop-blur-sm lp-border lp-rounded-2xl lp-p-6 lp-transition-all lp-duration-700 hover:lp-shadow-[0_0_20px_rgba(221,184,137,0.1)]"
      style={cardStyle}
    >
      <SectionTitle
        icon={MapPin}
        title={t('locationSection.locationDetails')} /* CHANGED: "Location Details" */
        colors={mergedColors}
      />
      <div className="lp-grid lp-grid-cols-1 md:lp-grid-cols-2 lp-gap-4">
        <p className="lp-flex lp-items-center lp-group">
          <MapPin
            size={20}
            className="lp-mr-3 lp-shrink-0 lp-transition-transform lp-duration-200 group-hover:lp-scale-110"
            style={iconStyle}
          />
          <span
            className="lp-transition-colors lp-duration-200 group-hover:lp-text-[#DDB889]"
            style={textStyle}
          >
            {location.city}, {location.country}
          </span>
        </p>
        <p className="lp-flex lp-items-center lp-group">
          <MapPin
            size={20}
            className="lp-mr-3 lp-shrink-0 lp-transition-transform lp-duration-200 group-hover:lp-scale-110"
            style={iconStyle}
          />
          <span
            className="lp-transition-colors lp-duration-200 group-hover:lp-text-[#DDB889]"
            style={textStyle}
          >
            {location.address}
          </span>
        </p>
        <p className="lp-flex lp-items-center lp-group">
          <Clock
            size={20}
            className="lp-mr-3 lp-shrink-0 lp-transition-transform lp-duration-200 group-hover:lp-scale-110"
            style={iconStyle}
          />
          <span
            className="lp-transition-colors lp-duration-200 group-hover:lp-text-[#DDB889]"
            style={textStyle}
          >
            {location.timeZone}
          </span>
        </p>
      </div>
    </div>
  );
};
